var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPlusK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.001,
    height: 59.001,
    viewBox: "0 0 60.001 59.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8880",
    "data-name": "Grupo 8880",
    transform: "translate(-141.761 2.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_2",
    "data-name": "Uni\\xF3n 2",
    d: "M7783.1,36.144h-.008a2.214,2.214,0,0,1-2.3-2.306V26.961l.016-.019-.55-26.5a2.886,2.886,0,0,1,2.826-2.949l6.359-.133a.562.562,0,0,1,.06,0A2.892,2.892,0,0,1,7792.4.195l.27,12.931,29.478-34.185a1.938,1.938,0,0,1,1.743-.8h8.462s3.71.608,1.724,3.835l-47.248,53.389a2.906,2.906,0,0,1-1.724.778Zm23.656-.168a2.63,2.63,0,0,1-2.192-1.172l-5.5-8.265a2.641,2.641,0,0,1,.226-3.219l3.905-4.376a2.633,2.633,0,0,1,4.08.187l9.367,12.64a2.633,2.633,0,0,1-2.113,4.2Zm18.217-6.342a1.991,1.991,0,0,1-1.991-1.993V20.251H7815.6a1.992,1.992,0,0,1-1.991-1.993V15.334a1.993,1.993,0,0,1,1.991-2h7.383V5.952a1.991,1.991,0,0,1,1.991-1.993h2.922a1.993,1.993,0,0,1,1.993,1.993v7.387h7.383a1.993,1.993,0,0,1,1.991,2v2.924a1.991,1.991,0,0,1-1.991,1.993h-7.383v7.389a1.993,1.993,0,0,1-1.993,1.993Z",
    transform: "translate(-7638 20)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPlusK);
export default __webpack_public_path__ + "static/media/check-plus-k.471259593a9bdcd5e3bac5eb1f18852c.svg";
export { ForwardRef as ReactComponent };